const ALLOWED_CTA_COLORS = ["#ffffff", "#059669", "#1988e2", "#e07b07"]

export function verifyCtaColor(color: string | undefined, defaultColor?: string): string {
  if (!color) {
    return defaultColor || ""
  }
  return ALLOWED_CTA_COLORS.includes(color.toLowerCase()) ? color : defaultColor || ""
}
